import React from 'react';
import Board from 'assets/img/board12.svg';
import Calender from 'assets/img/calender12.svg';
import OverviewIcon from 'assets/img/check-square4.svg';
import style from './ViewTabsBar.module.css';

/**
 * Top-level tab bar for switching between Overview, Board, and Calendar views.
 * Used when tabs are at the project level (e.g., in ProjectBoardTest).
 */
const ViewTabsBar = ({ boardViewType, setBoardViewType, isProjectRelatedBoard, isTemplateActive, isArchivedParent = false }) => {
  if (isTemplateActive) return null;

  return (
    <div className={style.tabs_bar_wrapper}>
      <div className={style.tabs_bar} role="tablist" aria-label="View type">
        {isProjectRelatedBoard && !isArchivedParent && (
          <button
            className={`${style.tab_btn} ${boardViewType === 'overview' ? style.tab_active : ''}`}
            role="tab"
            aria-selected={boardViewType === 'overview'}
            onClick={() => setBoardViewType('overview')}>
            <img src={OverviewIcon} alt="Overview" className={style.tab_icon} />
            Overview
          </button>
        )}
        <button
          className={`${style.tab_btn} ${boardViewType === 'board' ? style.tab_active : ''}`}
          role="tab"
          aria-selected={boardViewType === 'board'}
          onClick={() => setBoardViewType('board')}>
          <img src={Board} alt="Board" className={style.tab_icon} />
          Board
        </button>
        <button
          className={`${style.tab_btn} ${boardViewType === 'calendar' ? style.tab_active : ''}`}
          role="tab"
          aria-selected={boardViewType === 'calendar'}
          onClick={() => setBoardViewType('calendar')}>
          <img src={Calender} alt="Calendar" className={style.tab_icon} />
          Calendar
        </button>
      </div>
    </div>
  );
};

export default ViewTabsBar;
